'use strict';
/** family: Card **/
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var React = require('react');
var CardBody_1 = require('../CardBody');
var CardFooter_1 = require('../CardFooter');
var CardHeader_1 = require('../CardHeader');
var CardMenu_1 = require('../CardMenu');
var CardSeparator_1 = require('../CardSeparator');
var CardSubtitle_1 = require('../CardSubtitle');
var CardTitle_1 = require('../CardTitle');
var DropdownItem_1 = require('../DropdownItem');
var FontAwesome_1 = require('../FontAwesome');
var CLASS_NAME = 'i-card';
var Card = function (_a) {
	var ariaLabel = _a.ariaLabel,
		children = _a.children,
		className = _a.className,
		iconName = _a.iconName,
		border = _a.border,
		restProps = __rest(_a, [
			'ariaLabel',
			'children',
			'className',
			'iconName',
			'border',
		]);
	var _b;
	if (iconName && !ariaLabel) {
		console.warn('ariaLabel is required for the icon "' + iconName + '".');
	}
	return React.createElement(
		'article',
		__assign(
			{
				role: 'presentation',
				className: classNames(
					CLASS_NAME,
					className,
					((_b = {}), (_b[CLASS_NAME + '--border'] = border), _b)
				),
			},
			restProps
		),
		iconName &&
			React.createElement(
				'div',
				{ className: CLASS_NAME + '__icon', 'aria-label': ariaLabel },
				React.createElement(FontAwesome_1.FontAwesome, {
					name: iconName,
					size: FontAwesome_1.FontAwesome.Size.Large,
				})
			),
		React.createElement(
			'div',
			{ className: CLASS_NAME + '__wrapper' },
			children
		)
	);
};
exports.Card = Card;
Card.defaultProps = {
	tabIndex: -1,
};
Card.Header = CardHeader_1.CardHeader;
Card.Body = CardBody_1.CardBody;
Card.Footer = CardFooter_1.CardFooter;
Card.Separator = CardSeparator_1.CardSeparator;
Card.Title = CardTitle_1.CardTitle;
Card.Subtitle = CardSubtitle_1.CardSubtitle;
Card.Menu = CardMenu_1.CardMenu;
Card.ActionItem = DropdownItem_1.DropdownItem;
//# sourceMappingURL=Card.js.map
